import { City, Place, Product } from 'rest-client';

export function getPlace(cities: City[], placeId: number): Place {
  let result: Place;

  cities?.forEach((city: City) => {
    city.places?.forEach((place: Place) => {
      if (place.id === placeId) {
        result = place;
      }
    });
  });

  return result;
}

export function getProduct(place: Place, productId: number): Product {
  return place?.products?.find((product: Product) => product.id === productId);
}

export function getPlaces(cities: City[]): Partial<Place>[] {
  const result: Partial<Place>[] = [];

  cities.forEach((city: City) => {
    city.places.forEach((place: Place) =>
      result.push({ name: place?.name, id: place.id, type: place.type })
    );
  });

  return result;
}

export function getPlaceIdFromProductId(
  cities: City[],
  productId: number
): number {
  let result = null;

  cities.forEach((city: City) => {
    city.places.forEach((place: Place) => {
      const placeIdFound =
        place.products.find((product: Product) => product.id === productId) ||
        null;
      if (placeIdFound) {
        result = place.id;
      }
    });
  });

  return result;
}
